export class CountryCodeConstant {
  public static BEL='BEL';
  public static LUX='LUX';
  public static NLD='NLD';
  public static AUT='AUT';
  public static DEU='DEU';
  public static CHE = 'CHE';
}



// WEBPACK FOOTER //
// ./src/app/common/constants/country-code.constant.ts